import { Injectable, NgModule } from '@angular/core';
import { PatientsModalComponent } from './patients-modal.component';
import { BaseModule } from '../../shared/base.module';
import { MyDatePickerModule } from 'mydatepicker';
import {PopoverModule} from "ngx-bootstrap/popover";

import { MatInputModule } from '@angular/material/input';
import {MatSelectModule} from "@angular/material/select";

@NgModule({
    imports: [
        BaseModule,
        MyDatePickerModule,
        MatInputModule,
        MatSelectModule,
        PopoverModule.forRoot()
    ],
    exports: [PatientsModalComponent],
    declarations: [PatientsModalComponent],
    providers: [],
})
export class PatientsModalModule {
}
